module.exports = __webpack_public_path__ + "static/media/steiner.62b95c8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/steiner.png
// module id = 110
// module chunks = 0